import {ProductBrand, ProductInterface} from '../../interfaces/product/ProductInterface';

export function shouldHideWarranty(product?: Pick<ProductInterface, 'show_warranty' | 'normalized_brand_name'> | null): boolean {
    if (!product) {
        return false;
    }

    if (typeof product.show_warranty === 'boolean') {
        return !product.show_warranty;
    }

    return product.normalized_brand_name === ProductBrand.FILLINN;
}
